import { stateKey } from '../../../../../app/state-key.js';
import { manualNumericFacetSelector } from '../../../../../features/commerce/facets/numeric-facet/manual-numeric-facet-selectors.js';
import { manualNumericFacetReducer as manualNumericFacetSet } from '../../../../../features/commerce/facets/numeric-facet/manual-numeric-facet-slice.js';
import { toggleExcludeNumericFacetValue, toggleSelectNumericFacetValue, updateManualNumericFacetRange, } from '../../../../../features/commerce/facets/numeric-facet/numeric-facet-actions.js';
import { loadReducerError } from '../../../../../utils/errors.js';
import { buildCoreCommerceFacet, } from '../headless-core-commerce-facet.js';
/**
 * @internal
 *
 * **Important:** This initializer is meant for internal use by headless only.
 * As an implementer, you must not import or use this initializer directly in your code.
 * You will instead interact with `NumericFacet` sub-controller instances through the state of a `FacetGenerator`
 * sub-controller.
 *
 * @param engine - The headless commerce engine.
 * @param options - The `NumericFacet` options used internally.
 * @returns A `NumericFacet` sub-controller instance.
 */
export function buildCommerceNumericFacet(engine, options) {
    const coreController = buildCoreCommerceFacet(engine, {
        options: {
            ...options,
            toggleSelectActionCreator: toggleSelectNumericFacetValue,
            toggleExcludeActionCreator: toggleExcludeNumericFacetValue,
        },
    });
    if (!loadCommerceNumericFacetReducers(engine)) {
        throw loadReducerError;
    }
    const { dispatch } = engine;
    const { facetId, fetchProductsActionCreator } = options;
    return {
        ...coreController,
        // Only one range stored, so last will override the previous ones
        setRanges(ranges) {
            ranges.forEach((range) => {
                dispatch(updateManualNumericFacetRange({ facetId, ...range }));
            });
            dispatch(fetchProductsActionCreator());
        },
        get state() {
            const response = options.facetResponseSelector(engine[stateKey], facetId);
            return getNumericFacetState(coreController.state, response?.type === 'numericalRange' ? response : undefined, manualNumericFacetSelector(engine[stateKey], facetId));
        },
        type: 'numericalRange',
    };
}
function loadCommerceNumericFacetReducers(engine) {
    engine.addReducers({ manualNumericFacetSet });
    return true;
}
export const getNumericFacetState = (coreState, facetResponseSelector, manualFacetRangeSelector) => {
    const response = facetResponseSelector?.type === 'numericalRange'
        ? facetResponseSelector
        : undefined;
    return {
        ...coreState,
        ...(response?.domain && {
            domain: {
                min: response.domain.min,
                max: response.domain.max,
            },
        }),
        ...(manualFacetRangeSelector && { manualRange: manualFacetRangeSelector }),
        type: 'numericalRange',
    };
};
